<template lang="html">
  <div class="body-main">
    <div class="login-main">
      <div class="phone-body" v-show="!show">
        {{message.Nl127}}<br/>
        {{message.Nl128}}
      </div>
      <div class="box" @keyup.enter="onSubmit()" v-show="show">
        <!-- <img v-if="language==='zh-cn'" src="../../assets/config/config.banner-zh-CN.png" alt=""> -->
        <img src="../../assets/config/config.banner-en-US.png" alt="">
        <el-form ref="rulesForm" :model="form" :rules="rules" label-width="100%" label-position="top">
          <el-form-item :label="message.email+' / '+message.account" style="text-align:left" prop="email" auto-complete="off">
            <el-input v-model="form.email"></el-input>
            <div class="arrow" @click="showStorage" id="show-click" v-if="browser === 'qt'">
              <i class="material-icons" v-show="!storageShow">keyboard_arrow_down</i>
              <i class="material-icons" v-show="storageShow">keyboard_arrow_up</i>
            </div>
            <VuePerfectScrollbar @settings="settings" class="password-body" v-show="storageShow" id="show-body">
              <div class="cell" v-for="(item, index) in accountList" :key="item.id">
                <div class="name"  @click="chooseAccount(index)">{{item.account}}</div>
                <i class="material-icons" @click="clearAccount(index)">close</i>
              </div>
            </VuePerfectScrollbar>
          </el-form-item>
          <el-form-item :label="message.pass" style="text-align:left" prop="pass">
            <div class="login-reset" @click="toReset()">
              {{ message.forget }}
            </div>
            <el-input type="password" v-model="form.pass"></el-input>
          </el-form-item>
          <el-form-item  v-show="identifyingShow" :label="message.identifying" style="text-align:left" prop="identifying">
            <el-col :span="8">
              <el-input v-model="form.identifying"></el-input>
            </el-col>
            <el-col :span="4">&nbsp;</el-col>
            <el-col :span="12">
              <div class="identifying-main" @click="getIdentifying()">
                <img class="identifying-img" :src="identifyingUrl" alt="">
              </div>
            </el-col>
          </el-form-item>
          <el-form-item v-if="browser === 'qt'">
            <el-checkbox v-model="isRememberPassword">{{message.Fl121}}</el-checkbox>
            <el-checkbox v-model="isAutoLogin">{{message.Fl122}}</el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="width:100%;margin-top:10px" @click="onSubmit">{{ message.login }}</el-button>
          </el-form-item>
        </el-form>
        <!-- <div class="login-register" @click="toRegiser()">
          {{ message.register }}>>
        </div> -->
      </div>
      <div class="bottom">
        <div style="width:40%;float:left;font-size:28px;text-align:center;color:#606266;line-height:90px;">
          Powered by
        </div>
        <div style="width:60%;float:left;">
          <img src="../../assets/config/config.logo-en-US.png" alt="">
        </div>
      </div>
    </div>
    <!-- <div class="copy">
      Copyright © 2017 Cydex <a href="http://www.miitbeian.gov.cn/" target="_blank">沪ICP备17037446号</a>
    </div> -->
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { config, GetOs, getOsDetail } from '@/global'
export default {
  beforeRouteEnter (to, from, next) {
    if (config.browser === 'qt') {
      localStorage.removeItem('token')
    }
    if (localStorage.getItem('token')) {
      if (to.query.email && to.query.download) {
        next({ path: '/app/download/' + to.query.download })
      } else if (to.query.email && to.query.upload) {
        next({ path: '/app/upload/' + to.query.upload })
      } else {
        next({ path: '/app/workspace' })
      }
    } else {
      next()
    }
  },
  created () {
    this.$store.dispatch('activeApp', true)
  },
  components: {
    VuePerfectScrollbar
  },
  watch: {
    'isAutoLogin': function (val) {
      if (!val) {
        localStorage.removeItem('autoLogin')
      }
    }
  },
  data () {
    var checkEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$lang.ui.prompt.l155))
      } else {
        callback()
      }
    }
    var checkPass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$lang.ui.prompt.l101))
      } else {
        callback()
      }
    }
    var checkIdentifying = (rule, value, callback) => {
      if (this.identifyingShow) {
        if (!value) {
          return callback(new Error(this.$lang.ui.prompt.l104))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      show: true,
      storageShow: false,
      browser: this._global.config.browser,
      language: this._global.config.language,
      message: {
        login: this.$lang.ui.form.login,
        pass: this.$lang.ui.form.pass,
        email: this.$lang.ui.form.email,
        account: this.$lang.ui.form.account,
        register: this.$lang.ui.form.register,
        forget: this.$lang.ui.form.forget,
        identifying: this.$lang.ui.form.identifying,
        Nl127: this.$lang.ui.notice.l127,
        Nl128: this.$lang.ui.notice.l128,
        Fl121: this.$lang.ui.form.l121,
        Fl122: this.$lang.ui.form.l122,
        Pl154: this.$lang.ui.prompt.l154
      },
      identifyingShow: false,
      identifyingUrl: '',
      identifyingId: '',
      isRememberPassword: false,
      isAutoLogin: false,
      deviceId: '',
      form: {
        email: '',
        pass: '',
        identifying: ''
      },
      rules: {
        email: [
          { validator: checkEmail, trigger: 'blur' }
        ],
        pass: [
          { validator: checkPass, trigger: 'blur' }
        ],
        identifying: [
          { validator: checkIdentifying, trigger: 'blur' }
        ]
      },
      accountList: '',
      settings: {
        maxScrollbarLength: 0
      },
    }
  },
  mounted () {
    var query = this.$route.query
    if (query.email) {
      this.form.email = query.email
    }
    this.deviceId = localStorage.getItem('device_uuid')
    if (query.uuid) {
      this.deviceId = query.uuid
    }
    if (this._global.config.system === 'ios' || this._global.config.system === 'android') {
      this.show = false
    }
    if (!localStorage.getItem('token')) {
      this.$app.logout()
    }
    this.autoLogin()
    this.rememberPassword()
    document.addEventListener('click', this.closeStorageShow)
  },
  destroyed () {
    document.removeEventListener('click', this.closeStorageShow)
  },
  methods: {
    toReset () {
      this.$router.push({ path: '/app/reset' })
    },
    onSubmit () {
      this.os_type = GetOs()
      this.os_detail = getOsDetail()
      this.$refs['rulesForm'].validate((valid) => {
        if (this.form.email.indexOf('@') !== -1) {
          var e = {
            'email': this.form.email,
            'password': this.form.pass,
            'device_uuid': this.deviceId,
            'captcha_id': this.identifyingId,
            'input_value': this.form.identifying,
            'os_type': this.os_type,
            'os_detail': this.os_detail
          }
        } else {
          e = {
            'account': this.form.email,
            'password': this.form.pass,
            'device_uuid': this.deviceId,
            'captcha_id': this.identifyingId,
            'input_value': this.form.identifying,
            'os_type': this.os_type,
            'os_detail': this.os_detail
          }
        }
        if (valid) {
          this.$http.post('/cydex/api/v1/login', e)
            .then(response => {
              localStorage.setItem('token', response.data.token)
              localStorage.setItem('uid', response.data.user_id)
              localStorage.setItem('device_uuid', this.deviceId)
              if (this.isRememberPassword) {
                var e = {
                  account: this.form.email,
                  password: this.form.pass
                }
                this.setRememberPassword(e)
              }
              if (this.isAutoLogin) {
                e = {
                  account: this.form.email,
                  password: this.form.pass
                }
                this.setAutoLogin(e)
              } else {
                localStorage.removeItem('autoLogin')
              }
              sessionStorage.removeItem('autoLogin')
              if (this.browser === 'qt') {
                this.$router.push({ path: '/app/workspace/transfer' })
              } else {
                if (this.$route.query.download) {
                  this.$router.push({ path: '/app/download/' + this.$route.query.download })
                } else if (this.$route.query.upload) {
                  this.$router.push({ path: '/app/upload/' + this.$route.query.upload })
                } else {
                  this.$router.push({ path: '/app/workspace' })
                }
              }
            })
            .catch(error => {
              if (error.response.data.errno === 233) {
                this.$router.push({ path: '/app/phone?token=0&email=' + this.form.email })
              }
              if (error.response.data.errno) {
                if (this.identifyingShow) {
                  this.identifyingId = error.response.data.captcha_id
                  this.identifyingUrl = error.response.data.pic_url
                }
                if (error.response.data.err_cnt >= 3 || error.response.data.errno === 195) {
                  this.identifyingShow = true
                  this.identifyingId = error.response.data.captcha_id
                  this.identifyingUrl = error.response.data.pic_url
                }
              }
            })
        }
      })
    },
    showStorage () {
      this.storageShow = !this.storageShow
    },
    closeStorageShow (el) {
      if (this.browser !== 'qt') {
        return
      }
      var a = document.querySelector('#show-body')
      var b = document.querySelector('#show-click')
      if (!a.contains(el.target) && !b.contains(el.target)) {
        this.storageShow = false
      }
    },
    autoLogin () {
      if (localStorage.getItem('autoLogin')) {
        var data = JSON.parse(JSON.parse(JSON.stringify(localStorage.getItem('autoLogin'))))
        if (sessionStorage.getItem('autoLogin') === 'false') {
          this.form.email = data.account
          this.form.pass = data.password
          this.isAutoLogin = true
          this.isRememberPassword = true
        } else {
          this.form.email = data.account
          this.form.pass = data.password
          this.isAutoLogin = true
          this.isRememberPassword = true
          this.onSubmit()
        }
      }
    },
    rememberPassword () {
      if (!localStorage.getItem('rememberPassword')) {
        return
      }
      this.accountList = JSON.parse(JSON.parse(JSON.stringify(localStorage.getItem('rememberPassword')))).storage
    },
    setAutoLogin (e) {
      localStorage.setItem('autoLogin', JSON.stringify(e))
    },
    setRememberPassword (e) {
      if (localStorage.getItem('rememberPassword')) {
        var a = JSON.parse(JSON.parse(JSON.stringify(localStorage.getItem('rememberPassword'))))
        var isHas = false
        for (var i = 0; i < a.storage.length; i++) {
          if (a.storage[i].account === e.account) {
            a.storage[i].password = e.password
            isHas = true
          }
        }
        if (!isHas) {
          a.storage[a.storage.length] = e
        }
      } else {
        a = { storage: [e] }
      }
      localStorage.setItem('rememberPassword', JSON.stringify(a))
    },
    chooseAccount (index) {
      this.form.email = this.accountList[index].account
      this.form.pass = this.accountList[index].password
      this.storageShow = false
    },
    clearAccount (index) {
      this.accountList.splice(index, 1)
      var e = { storage: this.accountList }
      localStorage.setItem('rememberPassword', JSON.stringify(e))
    },
    getIdentifying () {
      this.$http.get('/cydex/api/v1/captcha')
        .then(response => {
          this.identifyingUrl = response.data.pic_url
          this.identifyingId = response.data.captcha_id
        })
    }
  }
}
</script>

<style lang="css" scoped>
.body-main {
  position: relative;
  overflow: hidden;
  height: 100%;
  min-width: 430px;
  min-height: 740px;
}
.phone-body {
  width: 80%;
  margin: 0 auto;
  margin-top: 48%;
  font-size: 20px;
}
.copy {
  position: absolute;
  font-size: 14px;
  bottom: 12px;
  width: 100%;
  color: #888;
  text-align: center;
}
.copy a {
  color: #888;
}
p {
  text-align: center;
  font-weight: 600;
  font-size: 18px;
}
.login-main {
  position: absolute;
  display: block;
  width: 420px;
  margin-left: -210px;
  left: 50%;
  top: 7%;
  padding: 0;
  border: 0;
}
.login-main .box{
  position: relative;
  overflow: hidden;
  border: 1px solid #999;
  border-radius: 8px;
  padding: 35px 60px 45px 60px;
}
.login-main .bottom{
  position: relative;
  overflow: hidden;
  padding: 0 10px;
  width: 100%;
}
.box img {
  display: block;
  width: 330px;
  margin-left: -15px;
  margin-bottom: 5px;
}
.bottom img {
  display: block;
  width: 100%;
  margin: 0 auto;
}
.identifying-main {
  width: 100%;
  height: 36px;
  overflow: hidden;
}
.identifying-img {
  margin-top: -8px;
  width: 100% !important;
}
.login-register {
  position: absolute;
  bottom: 15px;
  font-size: 15px;
  right: 50px;
  cursor: pointer;
  color: #20a0ff;
}
.login-reset {
  position: absolute;
  top: -34px;
  font-size: 14px;
  right: 5px;
  cursor: pointer;
  color: #20a0ff;
}
.password-body {
  z-index: 9999;
  position: absolute;
  width: 100%;
  top: 60px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  height: 180px;
}
.arrow {
  position: absolute;
  top: 6px;
  right: 6px;
  cursor: pointer;
  color: #c0c4cc;
}
.arrow:hover {
  color: #212121;
}
.arrow i {
  font-size: 28px;
}
.password-body .cell {
  position: relative;
  width: 100%;
  line-height: 40px;
  border-radius: 2px;
  padding: 0 15px;
  margin-bottom: 5px;
}
.password-body .cell:hover {
  background-color: #e4e7ed;
}
.password-body .cell .name {
  width: calc(100% - 40px);
}
.password-body .cell i {
  z-index: 3;
  cursor: pointer;
  font-size: 20px;
  position: absolute;
  top: 10px;
  right: 20px;
  color: #ccc;
}
.password-body .cell i:hover {
  color: #212121;
}
</style>
